<template>
  <div id="app-index">
    <about-head></about-head>
    <pub-nav></pub-nav>
    <about-nav></about-nav>
    <about-foot></about-foot>
  </div>
</template>
<script>
import animate from 'animate.css'
import aboutHead from "../Public/head";
import pubNav from "../Public/nav";
import aboutNav from "./about_nav";
import aboutFoot from "../Public/foot";    

export default {
  components:{
    aboutHead,
    pubNav,
    aboutFoot,
    aboutNav
  }
}
</script>



// WEBPACK FOOTER //
// src/components/About/about_index.vue